/*
 * Quick add for collection page product cards.
 * Posts to the store's own /cart/add.js, then reuses the theme's cart
 * notification. Does not load or call anything outside this store.
 */
(function () {
  'use strict';

  if (window.sprinklyQuickAddLoaded) {
    return;
  }
  window.sprinklyQuickAddLoaded = true;

  var OPEN_CLASS = 'quick-add--open';
  var LOADING_CLASS = 'quick-add--loading';
  var ADDED_CLASS = 'quick-add__button--added';

  function route(name, fallback) {
    var routes = window.theme && window.theme.routes;
    return (routes && routes[name]) || fallback;
  }

  function getNotification() {
    var list = document.querySelectorAll('cart-notification');
    return list.length ? list[list.length - 1] : null;
  }

  function setMessage(root, text, isError) {
    var el = root.querySelector('[data-quick-add-message]');
    if (!el) {
      return;
    }
    el.textContent = text || '';
    el.classList.toggle('quick-add__message--error', !!isError);
  }

  function setOpen(root, open) {
    var toggle = root.querySelector('[data-quick-add-toggle]');
    var panel = root.querySelector('.quick-add__panel');
    if (!toggle || !panel) {
      return;
    }
    root.classList.toggle(OPEN_CLASS, open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (open) {
      var select = panel.querySelector('select');
      if (select) {
        select.focus();
      }
    }
  }

  function closeAll(except) {
    var open = document.querySelectorAll('[data-quick-add].' + OPEN_CLASS);
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) {
        setOpen(open[i], false);
      }
    }
  }

  function flashAdded(button) {
    if (!button) {
      return;
    }
    var original = button.getAttribute('data-original-label');
    if (original === null) {
      original = button.innerHTML;
      button.setAttribute('data-original-label', original);
    }
    button.textContent = 'Added \u2713';
    button.classList.add(ADDED_CLASS);
    window.setTimeout(function () {
      button.innerHTML = original;
      button.classList.remove(ADDED_CLASS);
    }, 2500);
  }

  function refreshCartCount() {
    return fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var counts = document.querySelectorAll('[data-cart-button-count]');
        for (var i = 0; i < counts.length; i++) {
          counts[i].textContent = cart.item_count > 0 ? cart.item_count : '';
        }
      });
  }

  function addToCart(root, trigger) {
    if (root.classList.contains(LOADING_CLASS)) {
      return;
    }

    var select = root.querySelector('[data-quick-add-variant]');
    var variantId = select ? select.value : trigger.getAttribute('data-variant-id');
    if (!variantId) {
      setMessage(root, 'Please choose an option.', true);
      return;
    }

    var primary = root.querySelector('.quick-add__button');
    var notification = getNotification();
    var canRender =
      notification &&
      typeof notification.getSectionsToRender === 'function' &&
      typeof notification.renderContents === 'function' &&
      typeof notification.setActiveElement === 'function';

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (canRender) {
      body.append(
        'sections',
        notification
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',')
      );
      body.append('sections_url', window.location.pathname);
    }

    root.classList.add(LOADING_CLASS);
    setMessage(root, '');

    fetch(route('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.status) {
          var cartError = new Error(data.description || data.message || '');
          cartError.isCartError = true;
          throw cartError;
        }

        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              productVariantId: variantId,
              cartData: data
            });
          }
        } catch (e) {
          /* a listener failing must not stop the add */
        }

        setOpen(root, false);
        flashAdded(primary);

        var rendered = false;
        if (canRender && data.sections) {
          try {
            notification.setActiveElement(primary);
            notification.renderContents(data);
            rendered = true;
          } catch (e) {
            rendered = false;
          }
        }
        if (!rendered) {
          return refreshCartCount();
        }
      })
      .catch(function (error) {
        var text =
          error && error.isCartError && error.message
            ? error.message
            : 'Sorry, that could not be added. Please try again.';
        setMessage(root, text, true);
      })
      .then(function () {
        root.classList.remove(LOADING_CLASS);
      });
  }

  /* One delegated listener, so it keeps working after the theme re-renders
     the product grid for filters and sorting. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) {
      return;
    }

    var toggle = target.closest('[data-quick-add-toggle]');
    if (toggle) {
      var toggleRoot = toggle.closest('[data-quick-add]');
      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      closeAll(toggleRoot);
      setOpen(toggleRoot, willOpen);
      return;
    }

    var submit = target.closest('[data-quick-add-submit]');
    if (submit) {
      addToCart(submit.closest('[data-quick-add]'), submit);
      return;
    }

    if (!target.closest('[data-quick-add]')) {
      closeAll(null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }
    var open = document.querySelector('[data-quick-add].' + OPEN_CLASS);
    if (!open) {
      return;
    }
    setOpen(open, false);
    var toggle = open.querySelector('[data-quick-add-toggle]');
    if (toggle) {
      toggle.focus();
    }
  });
})();
